module.exports = __webpack_public_path__ + "static/media/meta.7fa6ef42.bin";